import { Outlet, createBrowserRouter } from "react-router-dom";
import ErrorPage from "../areas/error/ErrorPage";
import Home from "../areas/home/Home";
import About from "../areas/about/About";
import React from "react";
import Sessions from "../areas/sessions/Sessions";
import Registration from "../areas/events/Registration";
import User from "../areas/user/User";
import UserFavorites from "../areas/user/UserFavorites";
import Profile from "../areas/user/Profile";
import Votes from "../areas/user/Votes";
import UserSessions from "../areas/user/UserSessions";
import PrivacyTerms from "../areas/common/Privacy-Terms";
import CommunityGuidelines from "../areas/common/CommunityGuidelines";
import CodeOfConduct from "../areas/common/CodeOfConduct";
import Speakers from "../areas/speakers/Speakers";
import Sponsors from "../areas/partners/Partners";
import UserRouter from "../areas/user/UserRouter";
import Partners from "../areas/partners/Partners";
import Admin from "../areas/admin/Admin";
import Account from "../areas/account/Account";
import PartnerUsers from "../areas/partners/PartnerUsers";
import QuestionnairePage from "../areas/questionnaire/QuestionnairePage";
import RegisteredUsersPage from "../areas/events/RegisteredUsersPage";
import ProtectedRoute from "../ProtectedRoute";
import RequireRole from "../RequireRole";
import RegistrationSuccess from "../data/RegistrationSuccess";
import CommunicationTypesPage from "../areas/communicationTypes/pages/CommunicationTypesPage";
import CommunicationsListPage from "../areas/Communication/pages/CommunicationsListPage";
import Header from "../areas/common/Header";
import Footer from "../areas/common/Footer";

function Layout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export const router = createBrowserRouter([
  {
    path: "/*",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "events/:eventId/registered-users",
        element: <RegisteredUsersPage />,
      },
      {
        path: "speakers/*",
        element: <Speakers />,
      },
      {
        path: "partners",
        element: <Partners />,
      },
      {
        path: "privacy-terms",
        element: <PrivacyTerms />,
      },
      {
        path: "community-guidelines",
        element: <CommunityGuidelines />,
      },
      {
        path: "code-of-conduct",
        element: <CodeOfConduct />,
      },
      {
        path: "sponsors",
        element: <Sponsors />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "sessions",
        element: <Sessions />,
      },
      {
        path: "registration",
        element: (
          <ProtectedRoute>
            <Registration
              onShowRegisterClick={(id) => console.log(id)}
              onShowSessionsClick={(id) => console.log(id)}
              onShowSponsorshipTiersClick={(id) => console.log(id)}
              onShowSponsorsClick={(id) => console.log(id)}
            />
          </ProtectedRoute>
        ),
      },
      {
        path: "registration-success",
        element: <RegistrationSuccess />,
      },
      {
        path: "user",
        element: <UserRouter />,
        children: [
          {
            path: "",
            element: <User />,
          },
          {
            path: "favorites",
            element: <UserFavorites />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "sessions",
            element: <UserSessions />,
          },
          {
            path: "votes",
            element: <Votes />,
          },
        ],
      },
      {
        path: "admin",
        element: (
          <RequireRole roles={["Admin"]}>
            <Admin />
          </RequireRole>
        ),
      },
      {
        path: "questionnaire",
        element: <QuestionnairePage />,
      },
      {
        path: "account",
        element: (
          <RequireRole roles={["User"]}>
            <Account />
          </RequireRole>
        ),
      },
      {
        path: "communication-types",
        element: <CommunicationTypesPage />,
      },
      {
        path: "communication",
        element: <CommunicationsListPage />,
      },
      {
        path: "partner-users/:partnerId",
        element: <PartnerUsers />,
      },
    ],
  },
]);
